// extracted by mini-css-extract-plugin
export default {"edit-report-columns-popup":"EditReportColumnsPopup_edit-report-columns-popup__4xOiF","popup-header":"EditReportColumnsPopup_popup-header__fBjKs"};